import React from 'react'

import { PageStatus } from 'config/enums'

import { interWbSession } from '@interco/inter-webview-bridge'

export const useUserSegmentation = () => {
  const [userSegmentation, setUserSegmentation] = React.useState<string>()
  const [pageStatus, setPageStatus] = React.useState<PageStatus>(PageStatus.LOADING)

  React.useLayoutEffect(() => {
    interWbSession
      .getUserInfo()
      .then(({ segmentation }) => setUserSegmentation(segmentation))
      .catch(() => setUserSegmentation('DIGITAL'))
      .finally(() => setPageStatus(PageStatus.SUCCESS))
  }, [])

  return { userSegmentation, pageStatus }
}
